import { atom } from 'jotai'

type RateMealsModalState = {
  isOpen: boolean
}

export const rateMealsModalAtom = atom<RateMealsModalState>({
  isOpen: false
})
